/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { JobRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { DialogRouteSnapshot } from '@gh/core-ui';

import { JobFinderListItem, JobListFinderFilter } from './job-finder.model';

export interface JobFinderDialogConfig extends FinderDialogConfig {
  filter?: JobListFinderFilter;
  showFinalizedEnabled?: boolean;
  showDppEnabled?: boolean;
}

@Injectable()
export class JobFinderBusinessService implements InitDialogViewService<JobFinderDialogConfig> {
  constructor(private jobRest: JobRestService) {
  }

  initDialogView(route: DialogRouteSnapshot<JobFinderDialogConfig>): any {
    return {
      init: this.jobRest.getFinderInit(),
    };
  }

  findAllAsDataSource(filter: JobListFinderFilter): SlicedDataSource<JobFinderListItem> {
    return this.jobRest.findAllAsDataSource(filter);
  }
}
